module.exports = __webpack_public_path__ + "static/media/22.57e480b7.svg";